import { useMutation } from "@tanstack/react-query";
import { textSnip } from "~/api/documents/documents";

type TextSnipRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

type TextSnipPoint = {
  x: number;
  y: number;
};

type TextSnipRequest = {
  organizationId: string;
  projectId: string;
  pageId: string;
  rect: TextSnipRect;
  polygon?: TextSnipPoint[];
};

type TextSnipResponse = {
  text: string;
  pageId: string;
};

const TEXT_SNIP_TIMEOUT_MS = 15_000;

const postTextSnip = async ({
  organizationId,
  projectId,
  pageId,
  rect,
  polygon,
}: TextSnipRequest): Promise<TextSnipResponse> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), TEXT_SNIP_TIMEOUT_MS);

  try {
    return await textSnip(
      organizationId,
      projectId,
      pageId,
      polygon ? { rect, polygon } : { rect },
      undefined,
      controller.signal
    );
  } finally {
    clearTimeout(timeout);
  }
};

export const useTextSnipMutation = () => {
  return useMutation({
    mutationFn: postTextSnip,
    retry: false,
  });
};
